<script setup lang="ts">
defineProps<{
    value?: number | string;
    unit?: string;
}>();
</script>

<template>
    <div class="vehicle-info">
        <span class="font-weight-medium">{{ value ? value : "-" }}</span>
        <span v-if="unit">{{ unit }}</span>
    </div>
</template>

<style lang="scss" scoped>
.vehicle-info {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.125rem;
}
</style>
